/**
 * Entry point: wires the manifest and GameScene into the SDK.
 *
 * The SDK shell scenes (MainMenu, Lobby, GameOver…) use the default
 * Theme; the in-game scene paints its own warm cartoon background so
 * the two look distinct but not jarring.
 */
import { bootGame } from '@platform/sdk';
import GameScene from './GameScene.js';
import manifest from '../manifest.json';

bootGame({
  manifest,
  GameScene,
  parent: 'game'
});
